const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.datainsights.forwoodsafety.com',
    USER_TOKEN_URL: 'https://xs4lvvx9j9.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://4iti3f1o86.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.staging.datainsights.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.staging.datainsights.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.staging.datainsights.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.datainsights.forwoodsafety.com',
    WEBSOCKET: 'wss://ageuaq1co8.execute-api.us-west-2.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
